import script from "./BaseYmdForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseYmdForm.vue?vue&type=script&lang=ts&setup=true"

import "./BaseYmdForm.vue?vue&type=style&index=0&id=29cdde1a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29cdde1a"]])

export default __exports__